// Module
var code = "<svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.5 10.625a1 1 0 0 0 0-1.25l-1.72-2.149c-.59-.738-1.78-.32-1.78.625v4.298c0 .946 1.19 1.363 1.78.625l1.72-2.15z\"/></svg>";
// Exports
module.exports = code;